<template>
  <div class="reward-affiliate-report-page">
    <KTCodePreview v-bind:title="'Báo cáo hoa hồng Affiliate'">
      <template v-slot:preview>
        <!-- Filter section -->
        <b-row class="mb-5">
          <b-col md="3">
            <div class="search-col">
              <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.fromDate"
              ></date-picker>
              <span class="ml-1 mr-1"></span>
              <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.toDate"
              ></date-picker>
            </div>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model.trim="params.searchAffiliateUser"
              type="text"
              placeholder="Mã/Tên người dùng Affiliate"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model.trim="params.searchCustomer"
              type="text"
              placeholder="Mã/Tên khách hàng"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model.trim="params.productName"
              type="text"
              placeholder="Tên sản phẩm"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col md="3">
            <b-form-input
              v-model.trim="params.billNumber"
              type="text"
              placeholder="Mã hóa đơn"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model.trim="params.orderId"
              type="text"
              placeholder="Mã đơn hàng"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="2">
            <b-button
              variant="primary"
              size="sm"
              class="btn font-weight-bold btn-size"
              @click="onFilter()"
              :disabled="onLoading"
              >Tìm kiếm</b-button
            >
          </b-col>
        </b-row>

        <b-table
          :items="listRewardAffiliateReports"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
          class="reward-table"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>

          <template v-slot:cell(billNumber)="row">
            <div
              class="font-weight-bold hover text-primary"
              @click="onViewBill(row.item.billNumber)"
            >
              {{ row.item.billNumber }}
            </div>
          </template>

          <template v-slot:cell(customerName)="row">
            <div class="font-weight-bold">
              <span
                class="font-weight-bold hover text-primary"
                @click="onViewCustomer(row.item)"
                >{{ row.item.customerName }}</span
              >
              <br />
              <span class="font-weight-bold">{{
                row.item.customerPhoneNumber
              }}</span>
            </div>
          </template>

          <template v-slot:cell(billCreatedAt)="row">
            <div class="font-weight-bold">
              {{ formatDate(row.item.billCreatedAt, CLIENT_DATE_TIME) }}
            </div>
          </template>

          <template v-slot:cell(commissionStatus)="row">
            <span
              class="label font-weight-bold label-lg label-inline mb-2"
              :class="getCommissionStatusClass(row.item.commissionStatus)"
              v-b-tooltip.hover.bottom
              :title="
                getCommissionStatusTooltipTitle(row.item.commissionStatus)
              "
            >
              {{ getCommissionStatusText(row.item.commissionStatus) }}
            </span>
          </template>

          <template v-slot:cell(totalAmount)="row">
            {{ convertPrice(row.item.totalAmount) }}
          </template>

          <template v-slot:cell(commissionAmount)="row">
            {{ convertPrice(row.item.commissionAmount) }}
          </template>

          <template v-slot:cell(commissionRate)="row">
            {{ row.item.commissionRate }}%
          </template>
          <template v-slot:cell(affiliateUserName)="row">
            <span v-if="row.item.affiliateUserName">
              <span
                class="font-weight-bold"
                v-b-tooltip.hover.bottom
                title="Tên người giới thiệu"
              >
                {{ row.item.affiliateUserName }}
              </span>
              <br />
              <span v-b-tooltip.hover.bottom title="Mã người giới thiệu">
                {{ row.item.affiliateUserCode }}
              </span>
            </span>
            <span v-else>
              <span
                v-b-tooltip.hover.bottom
                title="Chưa được đồng bộ sang Affiliate"
              >
                N/A
              </span>
            </span>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <p class="mt-3 text-dark font-weight-bold">
              Hiển thị {{ startIndex }} - {{ endIndex }} trong số
              {{ totalItems }} bản ghi
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="page"
              :total-page="totalPages"
              :linkParams="{}"
              @page-change="fetchData()"
            >
            </BPaginationNavCustom>
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import { handleError, convertPrice, makeToastFaile } from '@/utils/common';
import { AFFILIATE_COMMISSION_STATUS } from '@/utils/enum';
import { AFFILIATE_COMMISSION_STATUS_NAME } from '@/utils/enum-name';

import {
  formatDate,
  CLIENT_DATE_TIME,
  DP_CONFIG,
  getSubtractDate,
  formatDBDate,
} from '@/utils/date';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  data() {
    return {
      CLIENT_DATE_TIME,
      onLoading: false,
      listRewardAffiliateReports: [],
      fields: [
        {
          key: 'billNumber',
          label: 'Mã hóa đơn',
          thStyle: { fontWeight: 600, color: '#181c32', width: '6%' },
        },
        {
          key: 'customerName',
          label: 'Khách hàng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
        },
        {
          key: 'quantity',
          label: 'SL',
          thStyle: { fontWeight: 600, color: '#181c32', width: '3%' },
          tdClass: 'text-center',
        },
        {
          key: 'totalAmount',
          label: 'Tổng tiền',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'commissionRate',
          label: '% HH',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-right',
        },
        {
          key: 'commissionAmount',
          label: 'Tiền HH',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'affiliateUserName',
          label: 'Người giới thiệu',
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-left',
        },
        {
          key: 'commissionStatus',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-center',
        },
        {
          key: 'billCreatedAt',
          label: 'Ngày tạo',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
        },
      ],
      totalPages: 1,
      totalItems: 0,
      page: 1,
      limit: 10,
      dpConfigs: DP_CONFIG,
      params: {
        fromDate: getSubtractDate(30),
        toDate: null,
        searchAffiliateUser: '',
        searchCustomer: '',
        productName: '',
        billId: '',
        orderId: null,
      },
    };
  },
  methods: {
    getCommissionStatusTooltipTitle(status) {
      switch (status) {
        case AFFILIATE_COMMISSION_STATUS.PENDING:
          return 'Hoá đơn chưa đến ngày xét duyệt';
        case AFFILIATE_COMMISSION_STATUS.APPROVED:
          return 'Hoá đơn đã hợp lệ';
        case AFFILIATE_COMMISSION_STATUS.REJECTED:
          return 'Hoá đơn đã được trả hàng';
        default:
          return 'Không xác định';
      }
    },
    onViewCustomer({ customerId, customerPhoneNumber }) {
      const routeData = this.$router.resolve({
        name: 'update-customer',
        query: { id: customerId, phoneNo: customerPhoneNumber },
      });
      window.open(routeData.href, '_blank');
    },
    onViewBill(billNumber) {
      const routeData = this.$router.resolve({
        name: 'list-bill',
        query: {
          id: billNumber,
        },
      });
      window.open(routeData.href, '_blank');
    },
    formatDate,
    convertPrice,
    getCommissionStatusClass(status) {
      switch (status) {
        case AFFILIATE_COMMISSION_STATUS.PENDING:
          return 'label-light-warning';
        case AFFILIATE_COMMISSION_STATUS.APPROVED:
          return 'label-light-success';
        case AFFILIATE_COMMISSION_STATUS.REJECTED:
          return 'label-light-danger';
        default:
          return 'label-light-secondary';
      }
    },
    getCommissionStatusText(status) {
      return AFFILIATE_COMMISSION_STATUS_NAME[status];
    },
    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-reward-affiliate-reports',
      });
      this.fetchData();
    },
    setParamFilter() {
      this.page = this.$route.query.page ?? 1;
      return {
        ...this.params,
        fromDate: formatDBDate(this.params.fromDate),
        toDate: formatDBDate(this.params.toDate),
        page: this.page,
        limit: this.limit,
      };
    },
    fetchData: async function () {
      try {
        if (!this.validateParams()) return;
        if (this.onLoading) return;
        this.onLoading = true;
        const params = this.setParamFilter();
        const {
          data: { data },
        } = await ApiService.query('affiliates/reports', { params });
        this.listRewardAffiliateReports = data.result;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
      } catch (error) {
        handleError(error);
      } finally {
        this.onLoading = false;
      }
    },
    validateParams() {
      if (!this.params.fromDate) {
        makeToastFaile('Vui lòng chọn ngày bắt đầu');
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Báo cáo', route: 'reward-affiliate-reports' },
      { title: 'Báo cáo hoa hồng Affiliate' },
    ]);
  },
  created() {
    this.fetchData();
  },
  computed: {
    startIndex() {
      return (this.page - 1) * this.limit + 1;
    },
    endIndex() {
      return this.page * this.limit;
    },
  },
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
  },
};
</script>

<style scoped>
.reward-table {
  background: #f7fafd;
}
.font-weight-bold {
  font-weight: 600 !important;
}
.text-primary {
  color: #007bff !important;
}
.hover {
  cursor: pointer;
}
.hover:hover {
  opacity: 0.7;
  text-decoration: underline;
}
.btn-size {
  width: 90px;
}
.search-col {
  display: flex;
  align-items: center;
}

.hover:hover {
  opacity: 0.7;
  text-decoration: underline;
}
</style>
